<template>
	
	<div class="wizard-component">
		<div class="inputs data-input">
			<p class="purple-label">Tenant #1</p>
			<div class="input-container" v-for="input in inputFields" :class="input.class" v-if="input.class === 'double'">
				<p class="subject">{{ input.subject }}</p>
				<div class="input-inner">
					<input :type="input.type" name="">
				</div>
				
				<span class="small-text">{{ input.comment }}</span>
			</div>
			<div class="input-container" v-else>
				<p class="subject">{{ input.subject }}</p>
				<div class="input-inner">
					<input :type="input.type" name="">
				</div>
			</div>
		</div>

	</div>

</template>


<script>
	import {mapGetters} from 'vuex';
    import {store} from '../../../store/index'
    export default {
	

		data: () => ({
			inputFields: [
				{
					subject: 'Name or company',
					type: 'text'
				},
				{
					subject: 'Address',
					type: 'text'
				},
				{
					subject: 'Zipcode',
					type: 'text',
					class: 'double'
				},
				{
					subject: 'City',
					type: 'text',
					class: 'double'
				},
				{
					subject: 'Email',
					type: 'text'
				},
				{
					subject: 'CVR',
					type: 'text'
				}
			]

		})

	}
</script>


<style></style>